import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building2, UserPlus } from 'lucide-react';
import LoadingSpinner from '../components/LoadingSpinner';
import { api } from '../services/api';

const SolicitarAcesso = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    setError('');
    
    try {
      await api.post('/auth/solicitar-acesso', {
        nome: data.nome,
        email: data.email,
        telefone: data.telefone,
        condominio: data.condominio,
        apartamento: data.apartamento,
        mensagem: data.mensagem
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao enviar solicitação');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="main-container flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-green-100">
              <UserPlus className="h-6 w-6 text-green-600" />
            </div>
            <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">
              Solicitação Enviada
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Sua solicitação de acesso foi enviada com sucesso. 
              Você receberá um email quando sua conta for aprovada.
            </p>
          </div>
          
          <div className="text-center">
            <button
              onClick={() => navigate('/login')}
              className="btn-primary"
            >
              Voltar ao Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-100">
            <Building2 className="h-6 w-6 text-primary-600" />
          </div>
          <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">
            Solicitar Acesso
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Preencha os dados abaixo para solicitar acesso ao sistema
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-4">
            <div>
              <label htmlFor="nome" className="label">
                Nome Completo *
              </label>
              <input
                {...register('nome', {
                  required: 'Nome é obrigatório',
                  minLength: {
                    value: 2,
                    message: 'Nome deve ter pelo menos 2 caracteres'
                  }
                })}
                type="text"
                className={errors.nome ? 'input-error' : 'input'}
                placeholder="Seu nome completo"
              />
              {errors.nome && (
                <p className="mt-1 text-sm text-red-600">{errors.nome.message}</p>
              )}
            </div>

            <div>
              <label htmlFor="email" className="label">
                Email *
              </label>
              <input
                {...register('email', {
                  required: 'Email é obrigatório',
                  pattern: {
                    value: /^\S+@\S+$/i,
                    message: 'Email inválido'
                  }
                })}
                type="email"
                className={errors.email ? 'input-error' : 'input'}
                placeholder="seu@email.com"
              />
              {errors.email && (
                <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
              )}
            </div>

            <div>
              <label htmlFor="telefone" className="label">
                Telefone
              </label>
              <input
                {...register('telefone')}
                type="tel"
                className="input"
                placeholder="(11) 99999-9999"
              />
            </div>

            <div>
              <label htmlFor="condominio" className="label">
                Condomínio *
              </label>
              <input
                {...register('condominio', {
                  required: 'Nome do condomínio é obrigatório'
                })}
                type="text"
                className={errors.condominio ? 'input-error' : 'input'}
                placeholder="Nome do seu condomínio"
              />
              {errors.condominio && (
                <p className="mt-1 text-sm text-red-600">{errors.condominio.message}</p>
              )}
            </div>

            <div>
              <label htmlFor="apartamento" className="label">
                Apartamento
              </label>
              <input
                {...register('apartamento')}
                type="text"
                className="input"
                placeholder="Ex: 101, Bloco A"
              />
            </div>

            <div>
              <label htmlFor="mensagem" className="label">
                Mensagem Adicional
              </label>
              <textarea
                {...register('mensagem')}
                rows={3}
                className="input"
                placeholder="Informações adicionais sobre sua solicitação..."
              />
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-md p-3">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex justify-center items-center"
            >
              {loading ? (
                <LoadingSpinner size="sm" className="mr-2" />
              ) : null}
              {loading ? 'Enviando...' : 'Solicitar Acesso'}
            </button>
          </div>

          <div className="text-center">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-500"
            >
              <ArrowLeft className="h-4 w-4 mr-1" />
              Voltar ao Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SolicitarAcesso;
